import {SET_SOCIAL_LINKS} from "../ActionTypes";

const initialState = {
  socialLinks:null
}

const SocialLinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SOCIAL_LINKS:
      return {...state, socialLinks: action.payload}
    default:
      return state
  }
}

export default SocialLinksReducer